<template>
    <div>
      <Head title="Gestão de Empresas" />
      <div class="shadow_box rounded-lg p-6">
        <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">Gestão de Empresas</h1>
        <data-table
          v-if="loadTable"
          search-label="Pesquisar por nome, e-mail ou CNPJ"
          v-model:columns="columns"
          route="companies/list"
          no-data-label="Nenhuma empresa cadastrada"
          no-result-label="Nenhuma empresa cadastrada"
        >
          <template #table.cell.content.company_status="{ value, row }">
            <div v-if="row.status">Ativo</div>
            <div v-if="!row.status">Inativo</div>
            <!-- switch-input v-model="row.status" labelChecked="Ativo" labelUnchecked="Inativo" @click="changeStatus(row)" /-->
          </template>
          <template #grid.content.body.company_status="{ value, row }">
            <div v-if="row.status">Ativo</div>
            <div v-if="!row.status">Inativo</div>
            <!-- switch-input v-model="row.status" labelChecked="Ativo" labelUnchecked="Inativo" @click="changeStatus(row)" /-->
          </template>

          <template #table.cell.content.detail="{ value, row }">
            <div class="inline-grid grid-cols-1">
              <Link :href="'employees/' + row.id" class="flex justify-center items-end font-roboto font-medium btn-primary uppercase w-full">Funcionários</Link>
            </div>
          </template>
          <template #grid.content.body.detail="{ value, row }">
            <div class="inline-grid grid-cols-1">
                <Link :href="'employees/' + row.id" class="flex justify-center items-end font-roboto font-medium btn-primary uppercase w-full">Funcionários</Link>
              </div>
          </template>

          <template #table.cell.content.actions="{ value, row }">
            <div class="inline-grid grid-cols-3 gap-4 ">
                <Link :href="'/companies-dashboard/' + row.id" class="flex">
                    <span><font-awesome-icon icon="fa-chart-column" class="text-primary text-lg cursor-pointer" /></span>
                </Link>
              <span @click="openModalEdit(row)"><font-awesome-icon icon="fa-pen-to-square" class="text-primary text-lg cursor-pointer" /></span>
              <span @click="openModalConfirmDelete(row)"><font-awesome-icon icon="fa-trash-can" class="text-red-600 text-lg cursor-pointer" /></span>
            </div>
          </template>
          <template #grid.content.body.actions="{ value, row }">
            <div class="inline-grid grid-cols-3 gap-4 ">
                <Link :href="'/companies-dashboard/' + row.id" class="flex">
                    <span><font-awesome-icon icon="fa-chart-column" class="text-primary text-lg cursor-pointer" /></span>
                </Link>
              <span @click="openModalEdit(row)"><font-awesome-icon icon="fa-pen-to-square" class="text-primary text-lg cursor-pointer" /></span>
              <span @click="openModalConfirmDelete(row)"><font-awesome-icon icon="fa-trash-can" class="text-red-600 text-lg cursor-pointer" /></span>
            </div>
          </template>

          <template #after.reload-button>
            <button class="flex justify-center items-end font-roboto font-medium btn-primary uppercase w-full" @click.prevent="openModalEdit({})">
              <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-2" /><span class=""> Adicionar Empresa</span>
            </button>
          </template>
        </data-table>
      </div>
      <modal-delete ref="modalDelete" @confirm="reloadTable"></modal-delete>
      <modal-edit :modal-scrollable="true" ref="modalEdit" title="Empresa" url="companies" @submitForm="reloadTable" :item="{user: {}, group: null, specialty: null, errors: {user: {}}}" :multipart="true">
        <template #form="{item}">
          <div class="hidden lg:block lg:w-1/2"></div>
          <switch-input @click="checkInactive($event, item)" v-model="item.status" class="w-full mt-6" label="Situação" labelChecked="Ativo" labelUnchecked="Inativo" />

          <text-input v-model="item.name" :error="item.errors.name"  class="lg:pr-6 mt-6 w-full lg:w-1/2"
                      label="Nome" />
          <email-input v-model="item.email" :error="item.errors.email" class="mt-6 w-full lg:w-1/2" label="E-mail" type="email" autocapitalize="off" />
          <mask-input v-model="item.cnpj" mask="##.###.###/####-##" :error="item.errors.cnpj" class="lg:pr-6 mt-6 w-full lg:w-1/2" label="CNPJ" />

          <phone-input v-model="item.contact" :error="item.errors.contact" class="mt-6 w-full lg:w-1/2" label="Contato" />

          <cep-input @updateAddress="(...args) => this.onUpdateAddress(item, ...args)" v-model="item.addresspostcode" :error="item.errors.addresspostcode" class="mt-6 lg:pr-6 w-full lg:w-2/6" label="CEP" />


            <text-input v-model="item.addressstreet" :error="item.errors.addressstreet"
                        class="mt-6 lg:pr-6 w-full lg:w-3/6" label="Logradouro" />
            <text-input v-model="item.addressnumber" :error="item.errors.addressnumber" class="mt-6 w-full lg:w-1/6"
                        label="Número" />
            <text-input v-model="item.addresscomplement" :error="item.errors.addresscomplement" class="mt-6 w-full"
                        label="Complemento" />
            <text-input v-model="item.addressneighborhood" :error="item.errors.addressneighborhood"
                        class="mt-6 lg:pr-6 w-full lg:w-1/3"
                        label="Bairro" />
            <text-input v-model="item.addresscity" :error="item.errors.addresscity" class="mt-6 lg:pr-6 w-full lg:w-1/3"
                        label="Cidade" />
            <select-input v-model="item.addressstate" :error="item.errors.addressstate" class="mt-6 w-full lg:w-1/3" label="Estado">
              <option :value="null" />
              <option v-for="(value, name, index) in states_options" :key="name" :value="name">{{ value }}</option>
            </select-input>
        <money-input v-model="item.value_plan_basic" :error="item.errors.value_plan_basic" class="lg:pr-6 mt-6 w-full lg:w-1/2"
                     label="Valor do Plano Básico" />
        <money-input v-model="item.value_plan_mediun" :error="item.errors.value_plan_mediun"
                     class="mt-6 w-full lg:w-1/2" label="Valor do Plano Médio" />
        <money-input v-model="item.value_plan_premium" :error="item.errors.value_plan_premium"
                     class="lg:pr-6 mt-6 w-full lg:w-1/2" label="Valor do Plano Premium" />

        </template>
      </modal-edit>
      <modal ref="modalDeleteInactive" :modal-scrollable="true" :modal-backdrop="true">
        <template #body>
          <div class="text-center">
            <font-awesome-icon icon="fa-trash-can" class="text-red-600 text-2xl" />
            <div class="mt-4 mb-4">
              Esta empresa possui funcionários(s), a empresa deve ser inativada para poder ser excluída.
            </div>
            <button type="button" class="px-6 py-2.5 bg-gray-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out" @click.prevent="this.$refs.modalDeleteInactive.showModal = false">Ok</button>
          </div>
        </template>
      </modal>
    </div>
</template>

<script>
import { computed } from 'vue';
import { Head, Link, useForm } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout/Layout'
import LoadingButton from '@/Shared/Components/LoadingButton'
import ModalDelete from '@/Shared/Modal/ModalDelete'
import ModalEdit from '@/Shared/Modal/ModalEdit'
import Modal from '@/Shared/Modal/Modal'
import DataTable from '@/Shared/Components/DataTable'
import SwitchInput from '@/Shared/Fields/SwitchInput'
import TextInput from '@/Shared/Fields/TextInput'
import EmailInput from '@/Shared/Fields/EmailInput'
import TextareaInput from '@/Shared/Fields/TextareaInput'
import PasswordInput from '@/Shared/Fields/PasswordInput'
import SelectInput from '@/Shared/Fields/SelectInput'
import MaskInput from '@/Shared/Fields/MaskInput'
import VueSelectInput from '@/Shared/Fields/VueSelectInput'
import PhotoInput from '@/Shared/Fields/PhotoInput'
import CepInput from '@/Shared/Fields/CepInput'
import PercentualInput from '@/Shared/Fields/PercentualInput'
import DateInput from '@/Shared/Fields/DateInput'
import MoneyInput from '@/Shared/Fields/MoneyInput'
import PhoneInput from '@/Shared/Fields/PhoneInput'

export default {
  props: {
    states_options: Object,
    class_entity_options: Object,
    sex_options: Object,
    professionals: Array,
  },
  components: {
    Head,
    Link,
    useForm,
    LoadingButton,
    ModalDelete,
    ModalEdit,
    Modal,
    DataTable,
    SwitchInput,
    TextInput,
    EmailInput,
    PasswordInput,
    SelectInput,
    MaskInput,
    VueSelectInput,
    TextareaInput,
    PhotoInput,
    CepInput,
    PercentualInput,
    DateInput,
    MoneyInput,
    PhoneInput,
  },
  layout: Layout,
  mounted() {

  },
  setup() {

  },
  data() {
    return {
      addresspostcode: '',
      addressstreet: '',
      addressnumber: '',
      addressneighborhood: '',
      addresscity: '',
      addressstate: '',
      addressphone: '',
      addresscomplement: '',
      typesPlans: [],
      types_plans_options: [],
      groups: [],
      loadTable: true,
      columns: [
        {
          uniqid: 'company_name',
          label: 'Nome',
          field: 'name',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => `${row.name}`,
        },
        {
          uniqid: 'company_cnpj',
          label: 'CNPJ',
          field: 'cnpj',
          visible: true,
          sortable: false,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => `${row.cnpj}`,
        },
        {
          uniqid: 'company_contact',
          label: 'Contato',
          field: 'contact',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm whitespace-nowrap overflow-hidden text-ellipsis',
          headerClass: 'p-4 text-left',
          format: (val, row) => `${row.contact}`,
        },
        {
          uniqid: 'company_status',
          label: 'Situação',
          field: 'status',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm whitespace-nowrap overflow-hidden text-ellipsis',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'detail',
          label: 'Funcionários',
          field: 'id',
          visible: true,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4',
        },
        {
          uniqid: 'actions',
          label: 'Ações',
          field: 'id',
          visible: true,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4',
        },
      ],
    }
  },
  methods: {
    changeStatus(item) {
      item.status = !item.status;
      this.$inertia.post("/companies/update-status", {id: item.id, status: item.status});
    },
    openModalConfirmDelete(item) {
      this.$refs.modalDelete.openModalDelete(item, `/companies/${item.id}`, `Deseja realmente excluir a empresa ${item.name}?`);

    },
    openModalEdit(i) {

      let item = {
        id: i.id,
        cnpj: i.cnpj,
        name: i.name,
        contact: i.contact,
        address: i.address ?? '',
        addressid: i.address_id ?? '',
        addresspostcode: i.postcode ?? '',
        addressstreet: i.street ?? '',
        addressnumber: i.number ?? '',
        addressneighborhood: i.neighborhood ?? '',
        addresscity: i.city ?? '',
        addressstate: i.state ?? '',
        addresscomplement: i.complement ?? '',
        email: i.email ?? '',
        value_plan_basic: i.value_plan_basic,
        value_plan_mediun: i.value_plan_mediun,
        value_plan_premium: i.value_plan_premium,
        status: i.status ?? true,
        migrate_appointments: false,
        try_inactive: false,
      }


      this.$refs.modalEdit.openModalEdit(item);
    },
    reloadTable() {
      this.loadTable = false;
      setTimeout(() => this.loadTable = true, 10);
    },

    deleteTypePlan(form, typePlan) {
      form.typesPlans.splice(form.typesPlans.indexOf(typePlan), 1);
    },
    deleteAddress(form, address) {
      form.addresses.splice(form.addresses.indexOf(address), 1);
    },
    onUpdateAddress(form, json) {
      form.addresscity = json.localidade;
      form.addressstate = json.uf;
      form.addressstreet = json.logradouro;
      form.addressneighborhood = json.bairro;
    },
    applyAllProfessional(item, appointment) {
      for(let i in item.appointments_in_progress) {
        let apt = item.appointments_in_progress[i];
        let professional = this.professionals.find(professional => professional.id == appointment.professional_id && professional.specialties.filter(specialty => specialty.id == apt.specialty_id).length && this.professionals_appointments[apt.id].filter(prof_appt => prof_appt.id == professional.id).length);
        if(professional) {
          apt.professional_id = appointment.professional_id;
        }
      }
      this.checkForInactive(item);
    },
    async filterProfessionals(professional, appointment) {
      let token = this.$page.props.csrf_token;
      for(let i in this.professionals) {
        let prof = this.professionals[i];
        if(prof.id !== professional.id && prof.specialties.filter(specialty => specialty.id == appointment.specialty_id).length) {
          const rawResponse = await fetch(`professionals/check-time`, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
              'X-CSRF-Token': token
            },
            body: JSON.stringify({
              date_start: appointment.date_start,
              date_end: appointment.date_end,
              professional_id: prof.id,
            })
          });
          const content = await rawResponse.json();
          if(content.allowed) {
            this.professionals_appointments[appointment.id].push(prof);
          }
        }
      }
      return this.professionals_appointments[appointment.id];
    },
  },
}
</script>
